export const formatBudgetRange = (
  minCents?: number | null,
  maxCents?: number | null
) => {
  if (!minCents && !maxCents) return ""
  const min = minCents ? `$${(minCents / 100).toLocaleString()}` : ""
  const max = maxCents ? `$${(maxCents / 100).toLocaleString()}` : ""
  return `${min} - ${max}`
}
